export default "__VITE_ASSET__a94e27c8__"